export const ASPIRE_HOSTED: boolean = import.meta.env.VITE_ASPIRE_HOSTED === 'true';
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION;
export const API_VERSION: string = import.meta.env.VITE_API_VERSION;

export const OTEL_EXPORTER_OTLP_ENDPOINT: string = import.meta.env.VITE_OTEL_EXPORTER_OTLP_ENDPOINT;
export const OTEL_EXPORTER_OTLP_HEADERS: string = import.meta.env.VITE_OTEL_EXPORTER_OTLP_HEADERS;
export const OTEL_RESOURCE_ATTRIBUTES: string = import.meta.env.VITE_OTEL_RESOURCE_ATTRIBUTES;
